import React from "react";
import { configureStore, createSlice } from "@reduxjs/toolkit";
import { Provider, useSelector, useDispatch } from "react-redux";

//user
export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    guestUser: false,
    isOTPRequested:false,
    uploadedProgress:0,
    isWaitUpload:false,
  },
  reducers: {
    //save user in redux
    saveUser: (state, action) => {
      state.user = action.payload;
    },
    saveGuestUser: (state, action) => {
      state.guestUser = action.payload;
    },
    updateIsOTPRequested: (state, action) => {
      state.isOTPRequested = action.payload;
    },
    updateUploadedProgress: (state, action) => {
      state.uploadedProgress = action.payload;
    },
    updatetIsWaitUpload: (state, action) => {
      state.isWaitUpload = action.payload;
    },
  },
});

//export action for class component
export const { saveUser, saveGuestUser, updateIsOTPRequested, updateUploadedProgress, updatetIsWaitUpload } = userSlice.actions;


//configure store with initialState reducer
export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
  },
});

//export hook for functional component
export function useStore() {
  //user
  const user = useSelector((state) => state.user.user);
  const guestUser = useSelector((state) => state.user.guestUser);
  const isOTPRequested = useSelector((state) => state.user.isOTPRequested);
  const uploadedProgress = useSelector((state) => state.user.uploadedProgress);
  const isWaitUpload = useSelector((state) => state.user.isWaitUpload);
  const dispatch = useDispatch();

  return {
    user,
    guestUser,
    isOTPRequested,
    uploadedProgress,
    isWaitUpload,
    saveUser: (payload) => dispatch(saveUser(payload)),
    saveGuestUser: (payload) => dispatch(saveGuestUser(payload)),
    updateIsOTPRequested: (payload) => dispatch(updateIsOTPRequested(payload)),
    updateUploadedProgress: (payload) => dispatch(updateUploadedProgress(payload)),
    updatetIsWaitUpload: (payload) => dispatch(updatetIsWaitUpload(payload)),
  };
}

export function StoreProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
